import styled from 'styled-components';
import { colors } from '../../../styles/Variables';

export const BannerContainer = styled.div`
    height: 480px;
    background-image: url(${props => props.backgroundImage});
    background-position: center;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: flex-start; 
    align-items: center;
    color: ${colors.white};
    position: relative;
    
    @media (max-width: 768px) {
        display: none;
    }
`;
export const BannerMobile = styled.div`
    display: none;

    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 4rem;
        gap: 0.5rem;
    }
`;
export const TextsWrapper = styled.div`
    text-align: center;
    padding-top: 1.5rem;
    
    h1 {
        font-weight: 600;
        font-size: 32px;
        background: linear-gradient(90deg, #C28121, #FDEBC8);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        
        @media (max-width: 1024px) {
            font-size: 28px; 
        }
        
        @media (max-width: 768px) {
            font-size: 18px;
            color: #C28121;
            -webkit-text-fill-color: initial;
        }
    }
    
    h1 strong {
        color: #FAE7C2;
        font-weight: 600;
        
        @media (max-width: 768px) {
            font-size: 18px;
            color: #C28121;
        }
    }
    
    h2 {
        font-weight: 600;
        font-size: 32px;
        color: #C38121;
        
        @media (max-width: 1024px) {
            font-size: 28px;
        }
        
        @media (max-width: 768px) {
            font-size: 18px;
        }
    }
    
    h2 strong {
        font-weight: 600;
        background: linear-gradient(90deg, #D5A357, #FAE7C2);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        
        @media (max-width: 768px) {
            font-size: 18px;
            color: #C28121;
            -webkit-text-fill-color: initial;
        }
    }
    
    @media (max-width: 768px) {
        display: block;
    }
`;